import React, { useEffect, useRef, useCallback, memo, useState } from 'react';
import { useField } from 'formik';
import {wrapComponent, extract, isDisplayStatus} from "../../utils";
import { Dialog } from 'primereact/dialog';
import {FormPageFieldComponentProps} from "../../../types/formPage";
const MARKDOWN_OPTIONS = {
    previewStyle: 'tab',//tab|vertical
    previewHighlight:true,
    atSyntax:true,
    initialEditType:'wysiwyg'//wysiwyg|markdown
}
const JSON_OPTIONS = {
    modes: ['tree','code','text','preview','view','form'],//tree|code|text|preview|view|form
    mode: 'tree',
    search: true,
    mainMenuBar: true,
    navigationBar: true,
    statusBar: true,
    colorPicker: true,
    enableSort: false,
    enableTransform: false,
    history: false,
    limitDragging: false,
    sortObjectKeys: false
}
const btn = (name, key = '', type = undefined) => ({ name, type, id: key || name.toLowerCase() })
const buttonsAll = [
    btn('Source'),
    btn('Bold'),
    btn('Italic'),
    btn('Underline'),
    btn('Strike Through', 'strikethrough'),
    btn('Divider', 'div1', 'divider'),
    btn('Eraser'),
    btn('Superscript'),
    btn('Subscript'),
    btn('UL', 'ul'),
    btn('OL', 'ol'),
    btn('Indent'),
    btn('Outdent'),
    btn('Left'),
    btn('Font'),
    btn('Fontsize'),
    btn('Paragraph'),
    btn('Class Span', 'classSpan'),
    btn('Brush'),
    btn('Image'),
    btn('Video'),
    btn('File'),
    btn('Copy Format', 'copyFormat'),
    btn('Cut'),
    btn('Copy'),
    btn('Paste'),
    btn('Select All', 'selectall'),
    btn('Line', 'hr'),
    btn('Table'),
    btn('Link'),
    btn('Symbol'),
    btn('Undo'),
    btn('Redo'),
    btn('Find'),
    btn('Preview'),
    btn('Print'),
]
const HTML_OPTIONS = {
    toolbar: true,// Show Toolbar
    inline: false,//Show Toolbar Inline
    textIcons: false,//Use Text Icons
    spellcheck: true,//Use Spell Check
    showCharsCounter: true,//Show Character Count
    showWordsCounter: true,//Show Word Count
    showXPathInStatusbar: true,//Show CSS Path
    toolbarButtonSize: 'medium',//[opt('Tiny'), opt('XSmall'), opt('Small'), opt('Medium'), opt('Large')]
    enter: 'P',//[opt('Paragraph (<P>)', 'P'), opt('Block (<DIV>)', 'DIV'), opt('Break (<BR>)', 'BR')]
    direction: 'auto', //Reading Direction [opt('Auto'), opt('LTR'), opt('RTL')]
    language: 'auto',// 'Language' [opt('Auto'),opt('AR'),opt('CS_CZ'),opt('DE'),opt('DE'),opt('EN'),opt('FR'),opt('HE'),opt('HU'),opt('ID'),opt('IT'),opt('JA'),opt('KO'),opt('NL'),opt('PL'),opt('PT_BR'),opt('RU'),opt('TR'),opt('ZH_CN'),opt('ZH_TW'),]
    // buttons: buttonsAll,
}
const TEXT_OPTIONS = {
    word_count: true
}
export const IframeEditorMemo = ({ editorMode, id, meta, setValue, extraConfig = {}, ...restProps }:any) => {
    const [isEditing, setEditing] = useState(false)
    const {width = '100%', height = '500px', full_screen=false} = extraConfig
    const editor = useRef<any>();
    const [dialogOpen, setDialogOpen] = useState(false)
    const disabled = isDisplayStatus(extraConfig, 'disable')
    console.log('**IframeEditorMemo**', {disabled, extraConfig})
    let extractDefaults = {}
    let merge = {}
    switch(editorMode){
        case 'json':
            merge = disabled ? {mode:'view'} : {}
            extractDefaults = JSON_OPTIONS
            break;
        case 'html':
            merge = {disabled}
            extractDefaults = HTML_OPTIONS
            break;
        case 'markdown':
            merge = {disabled}
            extractDefaults = MARKDOWN_OPTIONS
            break;
        default:
            extractDefaults = TEXT_OPTIONS
            break;
    }
    const fullSettings = extract(extractDefaults, extraConfig, merge, true) as any
    const sendMsg = (msg) => {
        if (editor.current) {
            msg['widget'] = id
            console.log('**EDITOR** Sending Editor Msg', msg, meta)
            editor.current.contentWindow.postMessage(JSON.stringify(msg), '*')
        }
    }
    useEffect( () => {
        if(!isEditing)sendMsg({
            msg: 'load',
            value: meta.value,
            settings: {
                ...fullSettings,

            },
        })
    }, [dialogOpen, meta.value, isEditing])
    console.log("**IFRAME**", extraConfig, restProps)
    useEffect(() => {
        const handler = (event) => {
            try {
                const data = JSON.parse(event.data)
                if (data['widget'] !== id) return
                console.log('**EDITOR** Editor Message', data)
                const mode = data['msg']
                switch (mode) {
                    case 'focus':
                    case 'load':
                        if (mode == 'focus') {
                            setEditing(true)
                        }
                        sendMsg({
                            msg: 'load',
                            value: meta.value,
                            settings: {
                                ...fullSettings,

                            },
                        })
                        break
                    case 'set':
                        if (!disabled && setValue) setValue(data['value'])
                        break
                    case 'blur':
                        if (!disabled && setValue) setValue(data['value'])
                        setEditing(false)
                        break
                }
            } catch (ignore) { }
        }
        const res = window.addEventListener('message', handler)
        // clean up
        return () => {
            window.removeEventListener('message', handler)
        }
    }, [])

    const iframe = () => <iframe ref={editor} style={{ border: 'none' }} src={`${process.env.REACT_APP_EXT_SERVER}/editor/${editorMode || 'text'}?widget=${id}`} width={dialogOpen ? '100%' : width} height={dialogOpen ? '100%' : height} />
    return <>
        {full_screen && (
            <>
                <i className={'pi pi-window-maximize'} style={{cursor:'pointer', float: 'right'}} onClick={() => setDialogOpen(true)} />
                {dialogOpen && <Dialog header={<h2>{extraConfig.label || restProps.details.field.name}</h2>} onHide={() => setDialogOpen(false)} visible={dialogOpen} draggable={false} closable={true} maximized={true}>{iframe()}</Dialog>}
            </> )}
                {!dialogOpen && iframe()}
        </>
}
export const BaseEditor = ({ onChange, extraConfig = {}, ...restProps }:FormPageFieldComponentProps) => {

    const [field, meta, helpers] = useField(restProps.name);
    const {display_as:editorMode = 'markdown'} = extraConfig as any
    const handleEditorChange = useCallback((newVal) => {
        console.log('**EDITOR** setValue Callback being called', newVal)
        helpers.setValue(newVal)
    }, [helpers]);
    console.log("**IFRAME**", meta, extraConfig, restProps)
    const comp = <IframeEditorMemo editorMode={editorMode} id={restProps.name} meta={meta}  setValue={ handleEditorChange} extraConfig={extraConfig} {...restProps}/>
    return wrapComponent( comp, extraConfig)
};


export default BaseEditor;

